import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import AbstractHover from './AbstractHover';
class HoverZone extends AbstractHover {
    bookedCapacities(zone) {
        return zone.categories.reduce((acc, current) => acc + current.booked, 0);
    }

    totalCapacities(zone) {
        return zone.categories.reduce((acc, current) => acc + current.all, 0);
    }

    renderCategory(categories, form, category) {
        const { default_language, currency } = form;

        const currencyOutput = Intl.NumberFormat(default_language, {
            style: 'currency',
            currency: currency
        });
        const price = [];
        categories.forEach(cat => {
            if (cat.uuid === category.uuid) {
                cat.rates.forEach(rate => {
                    price.push(rate.price);
                });
            }
        });

        return (
            <li key={category.uuid} className="category modal-popup-category" data-id={category.uuid}>
                <span>
                    <div className="category-icon" style={{ backgroundColor: category.color }} />
                    <div className="name">{category.name}</div>
                </span>
                <p>
                    <Trans i18nKey="fromRate" values={{ rate: currencyOutput.format(price.sort()[0]) }} />
                </p>
            </li>
        );
    }

    renderCategories(zone, categories, form) {
        return <ul className="categories">{zone.categories.map(this.renderCategory.bind(zone, categories, form))}</ul>;
    }

    renderContent() {
        let { zone, categories, form } = this.props;
        return (
            <div>
                <div className="category">{this.renderCategories(zone, categories, form)}</div>
            </div>
        );
    }
}

HoverZone.propTypes = {
    zone: PropTypes.object.isRequired
};

export default withTranslation()(HoverZone);
